var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExchange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.36,
    height: 14.36,
    viewBox: "0 0 14.36 14.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "exchange",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    d: "M13.707,3.263H2.228L4.378,1.114A.653.653,0,1,0,3.454.191L.191,3.454a.653.653,0,0,0,0,.923L3.454,7.641a.653.653,0,1,0,.923-.923L2.228,4.569H13.707a.653.653,0,0,0,0-1.305Z",
    transform: "translate(0)",
    fill: "#1fba30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    d: "M10.905,150.191a.653.653,0,0,0-.923.923l2.149,2.149H.653a.653.653,0,1,0,0,1.305H12.132l-2.149,2.149a.653.653,0,1,0,.923.923l3.264-3.264a.653.653,0,0,0,0-.923Z",
    transform: "translate(0 -143.473)",
    fill: "#1fba30"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.e1f912c46be4df58761fa3c5f2cd809a.svg";
export { ForwardRef as ReactComponent };